import { render, staticRenderFns } from "./FormConfirmationField.vue?vue&type=template&id=2d1a6e72&scoped=true"
import script from "./FormConfirmationField.vue?vue&type=script&lang=js"
export * from "./FormConfirmationField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1a6e72",
  null
  
)

export default component.exports